import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { useAuthQuery } from '../../../utils/queryUtils';
import { getPreferredRecording } from '../titles/utils/recording-utils';
import { recordingAssetQuery, RecordingAssetQueryOptions, recordingsQuery, RecordingsQueryOptions } from './queries';
import { Recording } from './types/recording';

export function useRecordings<T = Recording[]>(options?: RecordingsQueryOptions<T>) {
  return useAuthQuery(recordingsQuery(options), ['user', 'home']);
}

export function useRecording(programId: string, lifetimeId: string | undefined) {
  const query = useRecordings();
  return useMemo(() => {
    if (query.isLoading) {
      return { ...query, data: undefined };
    }

    if (!query.data) {
      return query;
    }

    const recording = getPreferredRecording(
      {
        platformTitleId: programId,
        lifetimeId: lifetimeId,
        recordings: query.data,
      },
      false,
    );

    return {
      ...query,
      data: recording,
    };
  }, [lifetimeId, programId, query]);
}

export function useRecordingAsset(options: RecordingAssetQueryOptions) {
  return useQuery(recordingAssetQuery(options));
}
